import React from 'react';
import { IconButton } from '@atlaskit/button/new';
import WarningIcon from '@atlaskit/icon/core/warning';
import CrossIcon from '@atlaskit/icon/glyph/cross';
import Modal, { ModalBody, ModalTransition } from '@atlaskit/modal-dialog';
import { Box, Flex, Stack, Text, xcss } from '@atlaskit/primitives';
import { token } from '@atlaskit/tokens';
import { useIntl } from '@atlassian/jira-intl';
import messages from './messages';

type Props = {
	isModalOpen: boolean;
	onCancel: () => void;
	offsetModalY?: number;
	title: string;
	description: string;
	missingFields: string[];
};

export const MissingFieldsModal = ({
	isModalOpen,
	onCancel,
	title,
	description,
	missingFields,
}: Props) => {
	const { formatMessage } = useIntl();
	return (
		<ModalTransition>
			{isModalOpen && (
				<Modal
					onClose={onCancel}
					stackIndex={8}
					testId="project-create-importer-upload-flow.common.ui.missing-fields-modal.modal"
				>
					<ModalBody>
						<Box paddingBlock="space.300">
							<Flex justifyContent="space-between" xcss={headerStyles}>
								<Box as="h1" xcss={headingStyles}>
									{title}
								</Box>
								<IconButton
									appearance="subtle"
									icon={CrossIcon}
									label={formatMessage(messages.closeLabel)}
									onClick={onCancel}
								/>
							</Flex>
							<Stack space="space.200">
								<Text color="color.text.subtle">{description}</Text>
								<Stack space="space.100" xcss={listStyles}>
									{missingFields.map((field) => (
										<Flex key={field} gap="space.100" alignItems="center">
											<WarningIcon color={token('color.icon')} label="" />
											<Text color="color.text.subtle">{field}</Text>
										</Flex>
									))}
								</Stack>
							</Stack>
						</Box>
					</ModalBody>
				</Modal>
			)}
		</ModalTransition>
	);
};

const headerStyles = xcss({
	width: '100%',
});

const headingStyles = xcss({
	font: token('font.heading.medium'),
	color: 'color.text',
	paddingBlockEnd: 'space.200',
});

const listStyles = xcss({
	maxHeight: '188px',
	overflowY: 'auto',
});
